
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/features/compliments",
      function () {
        return require("private-next-pages/features/compliments.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/features/compliments"])
      });
    }
  